import { useEffect } from "react";

const SITE = "https://eyadkm.com";

// Upsert a <meta> by attribute (name=... or property=...).
function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO({ title, description, keywords }) {
  const defaultTitle = "Eyad Kurd-Misto | Data Scientist";
  const defaultDescription =
    "Portfolio of Eyad Kurd-Misto, Ph.D. - Data Scientist specializing in machine learning, LLM/agentic systems, and end-to-end data pipelines.";
  const defaultKeywords =
    "data science, machine learning, LLM integration, probabilistic programming, forecasting, AWS Bedrock, computational science, Eyad Kurd-Misto";

  useEffect(() => {
    const t = title || defaultTitle;
    const d = description || defaultDescription;
    const url = SITE + window.location.pathname;

    document.title = t;
    setMeta("name", "description", d);
    setMeta("name", "keywords", keywords || defaultKeywords);

    // Keep Open Graph / Twitter / canonical in sync per route (helps JS-running
    // crawlers; the static tags in index.html cover non-JS scrapers).
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", t);
    setMeta("name", "twitter:description", d);
    setCanonical(url);

    return () => {
      document.title = defaultTitle;
    };
  }, [title, description, keywords]);

  return null;
}
